<template>
    <div class="content_list_page">
        <div v-wechat-title="$route.meta.title"></div>
        <p v-if="Loading" class="content_list_nav" style="text-align: center;line-height:160px"><mt-spinner type="triple-bounce"></mt-spinner></p>
        <div v-if="!Loading" class="content_list_nav">

            <div class="content" v-for="(item,index) in dataLists" :key="item.id" @click="listDetail(item,'时政快讯')">
                
                <div :class="item.image_url != '' ? 'content_right_nav' : 'content_right_navs'">
                        <div class="list_title">
                            <img src="./img/flame.png" alt="">
                            <span class="list_project">专题</span>
                            <p class="list_tit">{{item.title}}</p>
                        </div>
                        <div :class=" item.image_url != '' ? 'list_content' : 'list_contents'">
                            <p class="list_cont" v-for="item in previewAmountList" v-if="item.id == index" v-html="item.content">{{item.content}}</p>
                            <div :class=" item.image_url != '' ? 'list_path' : 'list_paths'">
                                <div class="list_path_left">
                                    <span>{{item.source}}</span>
                                    <span>{{item.pubDate}}</span>
                                </div>
                                <div class="list_path_right" v-for="item in shareNumber" :key="item.id">
                                    <span v-if="item.id == index &&item.share_num > 0"><i class="el-icon-share"></i>{{item.share_num}}</span>
                                    <span v-if="item.id == index && item.read_num > 0"><i class="el-icon-chat-line-square"></i>{{item.read_num}}</span>
                                </div>
                                
                            </div>
                        </div>
                </div>
                <div class="content_left" v-if="item.image_url != ''">
                    <img :src="item.image_url" alt="">
                    <!-- <img v-if="item.image_url == ''" style="border: 0.08rem solid rgb(230, 228, 228);" src="./img/defaultimg.png" alt=""> -->
                </div>
            </div>

        </div>
        <el-pagination
            v-if="!Loading"
            class="list_number"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
import {listApi , previewAmount , listDetails,generateSign} from '@/api/index'
import Bus from '@/Bus'
//列表参数
const getNewsColumnData = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5e09ab7ce4b0b14aa6e2e642",
    userId: "",
    appInfoId: "10"
}
// 预览获取前
const previewBefore = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
//预览量参数
const previewParameter= {
    type: 1,
    data: "",
    columnId: "",
    userId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            Loading:true,
            jumpRouting:true,
            getColumnData: Object.assign({}, getNewsColumnData),
            prwParameter: Object.assign({}, previewParameter),
            prwBefore: Object.assign({}, previewBefore),
            dataLists:[],
            total:0,
            previewAmountList:[],
            shareNumber:[],
            readingNumber:[],
        }
    },
    created(){
        this.getColumnData.columnId = this.$route.query.columnId == undefined ? '5e09ab7ce4b0b14aa6e2e642' : this.$route.query.columnId
        this.total = 0
        this.dataList(0)
    },
    methods:{
        dataList(num){
            const headers = { 
        'Sign': generateSign()
      };
            this.getColumnData.pageNum = num
            this.axios.post(listApi,this.getColumnData,{ headers }).then( res => {
                this.dataLists = res.data.data[0].list
                this.total = res.data.data[0].total
                this.previewMethods()
            })
        },
        handleSizeChange(val) {
            // console.log(val,'===================');
            this.getColumnData.pageSize = val
            this.total = 0
            this.dataList(0)
        },
        handleCurrentChange(val) {
            this.dataList(val - 1)
        },

        // 预览列表参数
        previewMethods(){
            this.shareNumber = [];
            this.readingNumber = [];
            this.previewAmountList = [];
            const headers = { 
        'Sign': generateSign()
      };

            this.dataLists.forEach((item,index) => {
                let shares = {};//阅读量
                let abstract = {};//摘要
                let listDetailsAbstract = {
                        type: 1,
                        columnName: item.columnName,
                        storyId: item.id,
                        userId: "",
                        appInfoId: "10"
                    }
                let listAbstract = {
                    type: 1,
                    id: item.id,
                    userId: "",
                    appInfoId: "10"
                }
                shares['id'] = index
                this.axios.post(previewAmount,listDetailsAbstract),{ headers }.then(res => {
                    shares['share_num'] = res.data.data[0].share_num
                    shares['read_num'] = res.data.data[0].read_num
                    this.shareNumber.push(shares)
                    // this.readingNumber.push(res.data.data[0].read_num)
                    
                })
                abstract['id'] = index
                this.axios.post(listDetails,listAbstract,{ headers }).then(res => {
                    abstract['content'] = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                    this.previewAmountList.push(abstract)
                    this.Loading = false
                })
            })
        },

        // 列表详情
        listDetail(type,title){
            let routeData = this.$router.resolve({ path: '/details', query: {  id: type.id,jsonUrl:type.jsonUrl ,title } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        timeChange(){
            var dateTemp = dateTime.slice(0, 10).replace(/-/g, '/') + ' ' + dateTime.slice(11, 19)
            var dateTimeStamp = new Date(dateTemp).getTime()
            var minute = 1000 * 60
            var hour = minute * 60
            var day = hour * 24
            var halfamonth = day * 15
            var month = day * 30
            var now = new Date().getTime()
            var diffValue = now - dateTimeStamp
            if (diffValue < 0) {
                return
            }
            var monthC = diffValue / month
            var weekC = diffValue / (7 * day)
            var dayC = diffValue / day
            var hourC = diffValue / hour
            var minC = diffValue / minute
            var result = ''
            if (monthC >= 1) {
                result = "" + parseInt(monthC) + "月前"
            } else if (weekC >= 1) {
                result = "" + parseInt(weekC) + "周前"
            } else if (dayC >= 1) {
                result = "" + parseInt(dayC) + "天前"
            } else if (hourC >= 1) {
                result = "" + parseInt(hourC) + "小时前"
            } else if (minC >= 1) {
                result = "" + parseInt(minC) + "分钟前"
            } else
                result = "刚刚";
            return result;
        }
    }
}
</script>
<style lang="">
    .list_cont section{
        display:none !important;
    }
    .list_cont p{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont div img{
        display:none !important;
    }
    .list_cont p img{
        display:none !important;
    }
    .list_cont div{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont p span{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont div span{
        font-size:14px !important;
        line-height:22px !important;
    }
    .list_cont p span img{
        display:none !important;
    }
    .list_cont div span img{
        display:none !important;
    }

    .list_number{
        text-align: center;
        padding:1.2rem 0;
    }
    .content_list_page{
        margin-top:20px;
        width:1200px;
        margin:0 auto;
        -moz-box-shadow:0 0 10px rgb(239, 239, 240);
        -webkit-box-shadow:0 0 10px rgb(206, 206, 209);
        box-shadow:0 0 10px rgb(184, 184, 187);
        background:#ffffff;
    }
    .content_list_nav{
        min-height:calc(100vh - 241px) !important;
        padding:44px 98px 0;
    }
    .content{
        cursor:pointer; 
        height:146px;
        width: 100%;
        padding-bottom: 76px;
    }
    .content_left{
        width:220px;
        height:145px;
        float:left;
        background:#F7F7F7;
    }
    .content_left img{
        width:100%;
        height:100%;
        border-radius:5px;
    }
    .content_right_nav{
        float:left;
        padding-right:30px;
    }
    .content_right_nav .list_title{
        height:30px;
        line-height: 30px;
    }
    .content_right_nav .list_title img{
        height:24px;
        margin-top:5px;
        float:left;
    }
    .content_right_nav .list_title .list_project{
        background:#D23B2A;
        width:50px;
        margin:5px 5px 0;
        height:24px;
        display:block;
        float:left;
        text-align: center;
        border-radius: 12px;
        font-size:16px;
        line-height:24px;
        color:#ffffff;
    }
    .content_right_nav .list_title .list_tit{
        text-align: left;
        font-family:Source Han Sans CN;
        font-weight:500;
        color:#1A1A1A;
        width:660px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:20px;
        float:left;
        color:rgba(26,26,26,1);
    }

    .content_right_navs{
        float:left;
        width: 100%;
        padding-right:30px;
    }
    .content_right_navs .list_title{
        height:30px;
        line-height: 30px;
    }
    .content_right_navs .list_title img{
        height:24px;
        margin-top:5px;
        float:left;
    }
    .content_right_navs .list_title .list_project{
        background:#D23B2A;
        width:50px;
        margin:5px 5px 0;
        height:24px;
        display:block;
        float:left;
        text-align: center;
        border-radius: 12px;
        font-size:16px;
        line-height:24px;
        color:#ffffff;
    }
    .content_right_navs .list_title .list_tit{
        text-align: left;
        font-family:Source Han Sans CN;
        font-weight:500;
        color:#1A1A1A;
        width:660px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:20px;
        float:left;
        color:rgba(26,26,26,1);
    }
    .list_contents{
        float:left;
        width: 100%;
        height:90px;
        margin-top:25px;
    }
    .list_contents .list_cont{
        height:46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color:#A1A1A1;
        font-size: 14px;
        line-height:22px;
        padding-top: 10px;
        border-top:1px solid #DCDCDC;
    }




    .list_content{
        float:left;
        width: 750px;
        height:90px;
        margin-top:25px;
    }
    .list_content .list_cont{
        height:46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color:#A1A1A1;
        font-size: 14px;
        line-height:22px;
        padding-top: 10px;
        border-top:1px solid #DCDCDC;
    }
    .list_path{
        width: 750px;
        height:16px;
        line-height:16px;
        padding-top: 20px;
    }
    .list_path .list_path_left{
        float:left;
        font-size:14px;
        color:rgba(180,180,180,1);
    }
    .list_path .list_path_left span{
        padding-right: 16px;
        cursor:pointer;
    }
    .list_path .list_path_right span{
        padding-left: 16px;
        cursor:pointer;
    }
    .list_path .list_path_right span i{
        padding-right: 4px;
        font-size:16px;
    }
    .list_path .list_path_right{
        float:right;
        font-size:14px;
        color:rgba(180,180,180,1);
    }

    .list_paths{
        width: 100%;
        height:16px;
        line-height:16px;
        padding-top: 20px;
    }
    .list_paths .list_path_left{
        float:left;
        font-size:14px;
        color:rgba(180,180,180,1);
    }
    .list_paths .list_path_left span{
        padding-right: 16px;
        cursor:pointer;
    }
    .list_paths .list_path_right span{
        padding-left: 16px;
        cursor:pointer;
    }
    .list_paths .list_path_right span i{
        padding-right: 4px;
        font-size:16px;
    }
    .list_paths .list_path_right{
        float:right;
        font-size:14px;
        color:rgba(180,180,180,1);
    }
</style>


// WEBPACK FOOTER //
// src/components/otherNavigation/currentPolitics.vue